<!-- A popup dialog to select a different brand -->
<app-choose-brand [displayBrandDialog] = "openBrandSelectionDialog" (chooseBrandEvent)="chooseBrand($event)"></app-choose-brand>

<!--- Generic header, inclusing current brand and a button to select another brand -->

<div class="grid">
    <div class="col-7">
        <p-message severity="info" text="{{titleMessage}}"></p-message>
    </div>
   <div class="col-1">
       <button pButton type="button" label="Brand" icon="pi pi-sitemap" iconPos="left" (click)="onChooseBrandClick($event)"  
            class="p-button-raised p-button-rounded">
        </button>
   </div>  
</div>

<br/>

<div class="grid">

    <p-card header="List of Viewable Documents" subheader="" styleClass="ui-card-light" >

        <p-table #dt [columns]="cols" [value]="viewableDocuments" selectionMode="single"  class="wal-table"
            sortMode="multiple" [paginator]="true" [rows]="15" >

            <ng-template pTemplate="caption">
                <div style="text-align: right">        
                    <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
                    <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($any($event.target).value, 'contains')" style="width:auto">
                </div>
            </ng-template>

            <ng-template pTemplate="header" let-columns>
                <tr>
						@for (col of columns; track col.field) {
							<th [pSortableColumn]="col.field"
								[style.display]="col.display"
								[style.width]="col.width">
								{{ col.header }}
								<p-sortIcon [field]="col.field"></p-sortIcon>
							</th>
						}
                    <th [ngStyle]="{'width': 'table-cell', 'display': '8%'}">
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pEditableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ col.formatter ? col.formatter(rowData) : rowData[col.field] }}
                            </td>
                        }

                    <td style="text-align:center">
                        @if(isSubmitShown) {
                            <button pButton type="button" icon="pi pi-times" [style]="{'width':'20px', 'height':'20px', 'margin-right':'2px'}"  
                                data-toggle="tooltip" data-placement="top" title="Delete viewable document" 
                                class="ui-button-danger" (click)="onRowDelete(rowData)">
                            </button>
                        }
                        <button pButton type="button" icon="pi pi-clone" [style]="{'width':'20px', 'height':'20px', 'margin-right':'2px'}"  
                            data-toggle="tooltip" data-placement="top" title="Copy URL to clipboard"
                            class="ui-button-danger" (click)="onRowCopy(rowData)">
                        </button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="summary" let-rowData>
                @if (isSubmitShown) {
                    <div style="text-align:left">
                        <button pButton type="button" label="Add" icon="pi fa-plus" iconPos="left" (click)="showDialogToAdd()"  
                            class="p-button-info wal-info p-button-rounded">
                        </button>  
                    </div>
                }
            </ng-template>    
        </p-table> 

        <p-footer>
            <mat-icon class="nav-caption wal-center">list_all</mat-icon>
        </p-footer>
    </p-card>

</div>

<p-dialog appendTo="body" header="Viewable Documents" [(visible)]="displayAddDialog" [focusOnShow]="false" 
        [responsive]="true" styleClass="wal-dialog"
        showEffect="fade" [modal]="true"   [style]="{ width: '50em' }">
    
        <p-card header="Add New Document" subheader="" class="ui-card-light" >
        
            <div>

                <div class="radio-group">
                    <h3>Select the Scope</h3>
                    <div class="radio-buttons">
                        <p-radioButton name="scope" value="BRAND" [(ngModel)]="documentScope" label="Brand"></p-radioButton>
                        <p-radioButton name="scope" value="COMMON" [(ngModel)]="documentScope" label="Common"></p-radioButton>
                    </div>
                </div>

                <br/>

                <h3>Choose the Document</h3>
                <div class="col-12">
                    <p-fileUpload #fileUploadControl name="viewableDocumentFile" [multiple]="false" 
                        styleClass="custom-upload" mode="advanced" [multiple]="false"
                        accept=".pdf,.png,.jpg,.jpeg,.txt,.doc,.xls,xlsx,.csv,.json" [maxFileSize]="10000000" [showUploadButton]="false"
                        [customUpload]="true" (onSelect)="onViewableDocumentFileAdd($event)" (onRemove)="onViewableDocumentFileRemove($event)"
                        [showCancelButton]="true" > 
                    </p-fileUpload>
                </div>

                <div class="footer-actions">

                    @if (isSubmitShown) {
                        <p-button label="Submit" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" 
                            (click)="onAddViewableDocument($event)" [disabled]="viewableDocumentFile == null">
                        </p-button>
                    }

                    <p-button label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" 
                        (click)="cancelDialogToAdd()">
                    </p-button>   
                    
                    <div id="idSpinner" [hidden]="isSpinnerHidden">
                        <div class="loader"></div>  
                    </div>

                </div>
    
            </div>
    
            <p-footer>
                <mat-icon class="nav-caption wal-center">picture_as_pdf</mat-icon>
            </p-footer>
        </p-card>

</p-dialog>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="viewable-documents"></p-confirmDialog>
